import React, { useEffect } from 'react'
import {  Outlet, useNavigate  } from 'react-router-dom'
import Classification from '../../components/Classification/Classification'
import Club from '../../components/Club/Club/Club'
import DetalisClub from '../../components/Club/DetailsClub/DetailsClub'
import Companies from '../../components/Companies/Companies/Companies'
import Details from '../../components/Companies/Details/Details'
import Header from '../../components/Header/Header'
import PriceItem from '../../components/PriceItem/PriceItem';
import SideNavbar from '../../components/SideNavbar/SideNavbar';


const Main = () => {
  let his = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  })
  return (
    <div>
        <Header />
        <Classification />
    </div>
  )
}

export default Main